export const am = {
  // App branding
  appName: 'Hekaya',

  // Navigation
  home: 'መነሻ',
  forYou: 'ለእርስዎ',
  myList: 'ዝርዝሬ',
  profile: 'መገለጫ',
  userProfile: 'የተጠቃሚ መገለጫ',

  // Authentication
  signIn: 'ግባ',
  signUp: 'ተመዝገብ',
  signOut: 'ውጣ',
  signInWithApple: 'በApple ግባ',
  signUpWithApple: 'በApple ተመዝገብ',
  signInWithGoogle: 'በGoogle ግባ',
  signUpWithGoogle: 'በGoogle ተመዝገብ',
  appleSignInFailed: 'በApple መግባት አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
  appleAuthExpired: 'የApple ኮድ ጊዜው አልፏል',
  appleAuthRetrying: 'በራስ-ሰር እንደገና እየሞከረ ነው...',
  appleAuthRetryFailed: 'በApple መግባት አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
  appleAuthMaxRetriesReached: 'በጣም ብዙ ሙከራዎች። እባክዎ ቆይተው እንደገና ይሞክሩ።',
  appleSignInCancelled: 'በApple መግባት ተሰርዟል።',
  appleAccountAlreadyExists: 'በዚህ Apple ID መለያ ቀድሞ አለ። እባክዎ ይግቡ።',
  appleAccountNotFound: 'በዚህ Apple ID መለያ አልተገኘም። እባክዎ መጀመሪያ ይመዝገቡ።',
  googleSignInFailed: 'በGoogle መግባት አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
  googleAuthRetrying: 'በራስ-ሰር እንደገና እየሞከረ ነው...',
  googleAuthMaxRetriesReached: 'በጣም ብዙ ሙከራዎች። እባክዎ ቆይተው እንደገና ይሞክሩ።',
  or: 'ወይም',
  email: 'ኢሜይል',
  emailOrPhone: 'ኢሜይል ወይም ስልክ',
  enterEmail: 'ኢሜይልዎን ያስገቡ',
  enterEmailOrPhone: 'ኢሜይልዎን ወይም ስልክ ቁጥርዎን ያስገቡ',
  emailOrPhonePlaceholder: 'email@example.com ወይም +251912345678',
  signInRequired: 'መግባት ያስፈልጋል',
  toWatchThisEpisode: 'ይህን ክፍል ለማየት',
  toAddEpisodeToFavorites: 'ይህን ክፍል ወደ ተወዳጆች ለማከል',
  pleaseSignInToWatch: 'ይህን ክፍል ለማየት እባክዎ ይግቡ',
  pleaseSignInToAddFavorite: 'ይህን ክፍል ወደ ተወዳጆች ለማከል እባክዎ ይግቡ',
  pleaseSignInToAddSerieFavorite: 'ይህን ተከታታይ ወደ ተወዳጆች ለማከል እባክዎ ይግቡ',
  pleaseSignInToSubscribe: 'ለመመዝገብ እባክዎ ይግቡ',
  pleaseSignInToAccessRewards: 'ሁሉንም ባህሪያት ለማግኘት እና ሽልማቶችዎን ለመከታተል እባክዎ ይግቡ።',
  subscriptionRequired: 'ምዝገባ ያስፈልጋል',
  episodeRequiresPremium: 'ይህ ክፍል ፕሪሚየም ምዝገባ ያስፈልገዋል',

  // Force update
  updateRequired: 'ዝመና ያስፈልጋል',
  currentVersion: 'የአሁኑ ስሪት',
  requiredVersion: 'የሚያስፈልገው ስሪት',
  updateNow: 'አሁን አዘምን',
  appCannotBeUsedWithoutUpdate: 'ያለ ዝመና መተግበሪያው ጥቅም ላይ ሊውል አይችልም',
  forceUpdateDefaultMessage: 'አዲስ የመተግበሪያ ስሪት ይገኛል። መተግበሪያውን መጠቀም ለመቀጠል እባክዎ ያዘምኑ።',

  // Recommended update
  updateAvailable: 'ዝመና ይገኛል',
  recommendedVersion: 'የሚመከር ስሪት',
  updateButton: 'አዘምን',
  laterButton: 'ቆይ',
  updateWillBeShownAgainIn24Hours: 'ይህ ዝመና ከ24 ሰዓታት በኋላ እንደገና ይታያል',
  recommendedUpdateMessage: 'አዲስ የመተግበሪያ ስሪት ከማሻሻያዎች እና አዳዲስ ባህሪያት ጋር ይገኛል። ለምርጥ ተሞክሮ እንዲያዘምኑ እንመክራለን።',

  // Errors
  error: 'ስህተት',
  pleaseFillAllFields: 'እባክዎ ሁሉንም መስኮች ይሙሉ',
  failedToCreateAccount: 'መለያ መፍጠር አልተሳካም',
  invalidCredentials: 'ልክ ያልሆነ መረጃ',
  accountDisabled: 'ይህ መለያ ተሰናክሏል',
  emailAlreadyExists: 'ይህ ኢሜይል ቀድሞ በሌላ መለያ ጥቅም ላይ ውሏል',
  phoneAlreadyExists: 'ይህ ስልክ ቁጥር ቀድሞ በሌላ መለያ ጥቅም ላይ ውሏል',
  invalidEmailFormat: 'እባክዎ ትክክለኛ ኢሜይል አድራሻ ያስገቡ',
  invalidPhoneFormat: 'እባክዎ ትክክለኛ ስልክ ቁጥር ያስገቡ',
  accountMergeNotSupported: 'በዚህ ኢሜይል አድራሻ መለያ ቀድሞ አለ። እባክዎ በመጀመሪያ የመግቢያ ዘዴዎ ይግቡ።',

  // Content
  searchDramas: 'ድራማዎችን ይፈልጉ...',
  noResultsFound: 'ለ"{query}" ውጤት አልተገኘም',
  searchResultsOne: 'ለ"{query}" 1 ውጤት',
  searchResultsMany: 'ለ"{query}" {count} ውጤቶች',
  allSeries: 'ሁሉም ተከታታዮች',
  topCharts: 'ከፍተኛ ደረጃ',
  recommendedForYou: 'ለእርስዎ የሚመከር',
  basedOnPreferences: 'በምርጫዎችዎ ላይ የተመሠረተ',
  continueWatching: 'ማየት ቀጥል',
  resumeWatching: 'ማየት ቀጥል',
  similarToWatched: 'ካዩት ጋር ተመሳሳይ',
  trendingSearches: 'ተወዳጅ ፍለጋዎች',
  noSeriesInProgress: 'በሂደት ላይ ያለ ተከታታይ የለም',
  startWatchingToSee: 'እዚህ ለማየት ተከታታይ ማየት ይጀምሩ',
  noContentAvailable: 'ይዘት አይገኝም',
  checkSupabaseConfig: 'እባክዎ የSupabase ውቅረትዎን ያረጋግጡ',

  // Series and episodes
  seasons: 'ወቅቶች',
  season: 'ወቅት',
  episodes: 'ክፍሎች',
  synopsis: 'ማጠቃለያ',
  episode: 'ክፍል',
  play: 'አጫውት',
  swipeToSeeMore: 'ተጨማሪ ለማየት ያንሸራትቱ',
  myListAction: 'ዝርዝሬ',
  addToMyList: 'ወደ ተወዳጆች ጨምር',
  removeFromMyList: 'ከተወዳጆች አስወግድ',
  popular: 'ተወዳጅ',
  new: 'አዲስ',
  trending: 'በመታወቅ ላይ',
  highlight: 'ዋና ዜና',
  free: 'ነፃ',
  premium: 'ፕሪሚየም',
  premiumEpisode: 'ፕሪሚየም ክፍል',
  signInToUnlock: 'ለመክፈት ይግቡ',
  subscribeToWatch: 'ለማየት ይመዝገቡ',

  // Profile
  subscribeToPremium: 'ወደ ፕሪሚየም ያሻሽሉ',
  subscribeWithDCB: 'በDCB ወደ ፕሪሚየም ያሻሽሉ',
  dcbSubscribeModalTitle: 'በሞባይል ክፍያ ምዝገባ',
  dcbSubscribeLoading: 'ክፍያ በማዘጋጀት ላይ...',
  dcbSubscribeError: 'የክፍያ ገጹን መጫን አልተቻለም።',
  dcbSubscribeRetry: 'እንደገና ሞክር',
  restorePurchases: 'ግዢዎችን ወደነበሩበት መልስ',
  purchaseProcessing: 'በማስኬድ ላይ...',
  subscriptionActivated: 'ምዝገባ በተሳካ ሁኔታ ነቅቷል!',
  webPaymentUnavailable: 'የድር ክፍያዎች በአሁኑ ጊዜ አይገኙም። እባክዎ ቆይተው እንደገና ይሞክሩ።',
  paymentInitializing: 'የክፍያ ስርዓቱ እየተጀመረ ነው። እባክዎ በጥቂት ሰከንዶች ውስጥ እንደገና ይሞክሩ።',
  loadingOffers: 'ቅናሾች በመጫን ላይ...',
  purchasesRestored: 'ምዝገባዎ በተሳካ ሁኔታ ተመልሷል! አሁን ወደ ሁሉም ፕሪሚየም ይዘት መዳረሻ አለዎት።',
  noPurchasesToRestore: 'ለመመለስ ንቁ ምዝገባዎች አልተገኙም። ይህ ስህተት ነው ብለው ካሰቡ፣ እባክዎ ድጋፍን ያነጋግሩ።',
  purchaseFailed: 'ግዢ አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
  restoreFailed: 'ግዢዎችን መመለስ አልተሳካም።',
  noActiveSubscription: 'ለመመለስ ንቁ ምዝገባ አልተገኘም።',
  iapNotAvailable: 'በመተግበሪያ ውስጥ ግዢዎች አይገኙም።',
  webPurchaseNotSupported: 'በድር ላይ በመተግበሪያ ውስጥ ግዢዎች አይገኙም። እባክዎ ሞባይል መተግበሪያውን ይጠቀሙ።',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'ወርሃዊ ፕሪሚየም ምዝገባ',
  premiumSubscriptionTagline: 'ወደ ሁሉም ድራማ ተከታታዮች እና ክፍሎች ያልተገደበ መዳረሻ ይክፈቱ',
  whatYouGet: 'የሚያገኙት',

  // Profile subscription information
  profileSubscriptionDescription: 'በወርሃዊ ምዝገባችን ወደ ሁሉም ድራማ ተከታታዮች እና ክፍሎች ያልተገደበ መዳረሻ ያግኙ።',
  profileBenefit1: 'ከሙሉ ቤተ-መጻሕፍታችን ማንኛውንም ክፍል ይመልከቱ',
  profileBenefit2: 'ወደ ሁሉም አዳዲስ ክፍሎች ፈጣን መዳረሻ',
  profileBenefit3: 'ያለ ማስታወቂያ የእይታ ተሞክሮ',

  premiumBenefit1: 'ወደ ሁሉም ድራማ ተከታታዮች ያልተገደበ መዳረሻ - ማንኛውንም ክፍል፣ በማንኛውም ጊዜ ይመልከቱ',
  premiumBenefit2: 'በመቶዎች የሚቆጠሩ ክፍሎች ያሉት የአሁኑ ይዘት ሙሉ ቤተ-መጻሕፍት',
  premiumBenefit3: 'ሁሉም አዳዲስ ክፍሎች ሲለቀቁ ወዲያውኑ መዳረሻ',
  premiumBenefit4: 'ያለ ገደብ ወይም ውስንነት ማንኛውንም ክፍል ይመልከቱ',
  premiumBenefit5: 'ያለ ማስታወቂያ የእይታ ተሞክሮ ለማያቋርጥ መዝናኛ',
  premiumBenefit6: 'ለምርጥ የእይታ ተሞክሮ ከፍተኛ ጥራት ያለው ቪዲዮ ዥረት',
  premiumBenefit7: 'በሁሉም መሣሪያዎችዎ ላይ መዳረሻ - ስልክ፣ ታብሌት እና ድር',
  bestValue: 'ምርጥ ዋጋ',
  subscriptionIncludes: 'ወደ ሁሉም ይዘት ሙሉ መዳረሻ',
  perMonth: '/ወር',
  perWeek: '/ሳምንት',
  startSubscription: 'ምዝገባ ጀምር',
  learnMoreAboutSubscription: 'ስለ ምዝገባ ተጨማሪ ይወቁ',

  // Subscription terms
  subscriptionTerms: 'በምዝገባ ማያ ገጹ ላይ በሚታየው ዋጋ በመለያዎ በኩል ይከፈላሉ። ምዝገባው ከመታደስ ቀኑ ቢያንስ 24 ሰዓታት ቀደም ብለው ካልሰረዙ በስተቀር በየወሩ በራስ-ሰር ይታደሳል። ክፍያዎች የአሁኑ የክፍያ ጊዜዎ ከማለቁ 24 ሰዓታት በፊት ይከናወናሉ።',

  // Subscription details modal
  subscriptionDetails: 'የምዝገባ ዝርዝሮች',
  whatIsIncluded: 'የተካተተው',
  subscriptionDetailsDescription: 'ወርሃዊ ፕሪሚየም ምዝገባዎ ወደ ቤተ-መጻሕፍታችን ውስጥ ያሉ ሁሉም ድራማ ተከታታዮች እና ክፍሎች ያልተገደበ መዳረሻ ይሰጥዎታል። ይህ ሁሉንም የአሁኑ ይዘት እና በምዝገባ ጊዜዎ ውስጥ የሚለቀቁ ሁሉንም አዳዲስ ክፍሎች ያካትታል። ያለ ገደብ በማንኛውም መሣሪያዎ ላይ በማንኛውም ጊዜ ማንኛውንም ክፍል ማየት ይችላሉ።',
  howBillingWorks: 'ክፍያ እንዴት ይሠራል',
  billingDescription: 'በምዝገባ ማያ ገጹ ላይ በሚታየው ዋጋ በመለያዎ በኩል ይከፈላሉ። ምዝገባው ከመታደስ ቀኑ ቢያንስ 24 ሰዓታት ቀደም ብለው ካልሰረዙ በስተቀር በየወሩ በራስ-ሰር ይታደሳል። ክፍያዎች የአሁኑ የክፍያ ጊዜዎ ከማለቁ 24 ሰዓታት በፊት ይከናወናሉ።',
  howToCancel: 'እንዴት ይሰረዛል',
  cancellationDescription: 'ወደ መሣሪያዎ ቅንብሮች በመሄድ በማንኛውም ጊዜ ምዝገባዎን መሰረዝ ይችላሉ። ለiOS: ቅንብሮች > [ስምዎ] > ምዝገባዎች። ለAndroid: Google Play Store > ምናሌ > ምዝገባዎች። ይህን መተግበሪያ ይምረጡ እና ምዝገባ ሰርዝ ይንኩ። ምዝገባዎ እስከ አሁኑ የክፍያ ጊዜ ማለቂያ ድረስ ንቁ ይቀራል።',
  cancellationDescriptionIos: 'ወደ መሣሪያዎ ቅንብሮች በመሄድ በማንኛውም ጊዜ ምዝገባዎን መሰረዝ ይችላሉ። ለiOS: ቅንብሮች > [ስምዎ] > ምዝገባዎች። ይህን መተግበሪያ ይምረጡ እና ምዝገባ ሰርዝ ይንኩ። ምዝገባዎ እስከ አሁኑ የክፍያ ጊዜ ማለቂያ ድረስ ንቁ ይቀራል።',
  cancellationDescriptionAndroid: 'ወደ መሣሪያዎ ቅንብሮች በመሄድ በማንኛውም ጊዜ ምዝገባዎን መሰረዝ ይችላሉ። ለAndroid: Google Play Store > ምናሌ > ምዝገባዎች። ይህን መተግበሪያ ይምረጡ እና ምዝገባ ሰርዝ ይንኩ። ምዝገባዎ እስከ አሁኑ የክፍያ ጊዜ ማለቂያ ድረስ ንቁ ይቀራል።',
  subscriptionExpiry: 'ምዝገባ ሲያልቅ ምን ይሆናል',
  expiryDescription: 'ከሰረዙ ወይም ምዝገባዎ ካለቀ፣ ወደ ፕሪሚየም ይዘት መዳረሻ ያጣሉ። ሆኖም ግን፣ የእይታ ታሪክዎ እና ተወዳጆችዎ ይቀመጣሉ። ወደ ሁሉም ፕሪሚየም ክፍሎች ሙሉ መዳረሻ ለማግኘት በማንኛውም ጊዜ እንደገና መመዝገብ ይችላሉ።',
  deviceCompatibility: 'የመሣሪያ ተኳኋኝነት',
  compatibilityDescription: 'ምዝገባዎ ተመሳሳይ መለያ በሚጠቀሙባቸው ሁሉም መድረኮች ላይ ይሠራል። የፕሪሚየም ጥቅሞችዎን ለማግኘት በማንኛውም መሣሪያ ላይ በተመሳሳይ መለያ ይግቡ።',
  helpFeedback: 'እርዳታ እና አስተያየት',
  language: 'ቋንቋ',
  notifications: 'ማሳወቂያዎች',
  notificationSettings: 'የማሳወቂያ ቅንብሮች',
  pushNotifications: 'የፑሽ ማሳወቂያዎች',
  enabled: 'ነቅቷል',
  disabled: 'ተሰናክሏል',
  enable: 'አንቃ',
  enabling: 'በማንቃት ላይ...',
  pushNotificationsEnabled: 'የፑሽ ማሳወቂያዎች በተሳካ ሁኔታ ነቅተዋል',
  pushNotificationsDisabled: 'የፑሽ ማሳወቂያዎች ተሰናክለዋል',
  enablePushNotificationsInSettings: 'ማሳወቂያዎችን ለመቀበል፣ እባክዎ በመሣሪያዎ ቅንብሮች ውስጥ ያንቁ።',
  openSettings: 'ቅንብሮችን ክፈት',
  pushNotificationsEnabledDescription: 'በዚህ መሣሪያ ላይ ማሳወቂያዎችን ይቀበላሉ',
  pushNotificationsDisabledDescription: 'ወቅታዊ ለመሆን ማሳወቂያዎችን ያንቁ',
  notificationCategories: 'የማሳወቂያ ምድቦች',
  notificationCategoriesDescription: 'ምን ዓይነት ማሳወቂያዎች መቀበል እንደሚፈልጉ ይምረጡ',
  newEpisodes: 'አዳዲስ ክፍሎች',
  newEpisodesDescription: 'አዳዲስ ክፍሎች ሲለቀቁ ማሳወቂያ ያግኙ',
  recommendations: 'ምክሮች',
  recommendationsDescription: 'ለእርስዎ የተበጁ የይዘት ጥቆማዎች',
  subscriptionReminders: 'የምዝገባ ማስታወሻዎች',
  subscriptionRemindersDescription: 'ስለ ምዝገባዎ ሁኔታ ማስታወሻዎች',
  rewardsNotifications: 'ሽልማቶች እና ስኬቶች',
  rewardsNotificationsDescription: 'ስለ ሽልማቶችዎ እና ግስጋሴዎ ዝመናዎች',
  marketingNotifications: 'ግብይት እና ማስተዋወቂያዎች',
  marketingNotificationsDescription: 'ልዩ ቅናሾች እና የማስተዋወቂያ ይዘት',
  failedToUpdatePreferences: 'የማሳወቂያ ምርጫዎችን ማዘመን አልተሳካም',
  failedToRequestPermission: 'የማሳወቂያ ፈቃድ መጠየቅ አልተሳካም',
  signInToSavePreferences: 'የማሳወቂያ ምርጫዎችዎን በሁሉም መሣሪያዎች ላይ ለማስቀመጥ ይግቡ',
  done: 'ተጠናቋል',
  contactUs: 'ያነጋግሩን',
  settings: 'ቅንብሮች',
  privacyPolicy: 'የግላዊነት ፖሊሲ',
  privacySettings: 'ግላዊነት እና ፈቃድ',
  cookieSettings: 'የኩኪ ቅንብሮቼ',
  localStorage: 'የአካባቢ ማከማቻ',
  termsConditions: 'ውሎች እና ሁኔታዎች',
  legalNotice: 'ሕጋዊ ማሳሰቢያ',
  pricingConditions: 'የዋጋ ሁኔታዎች',
  unsubscribe: 'ምዝገባ ሰርዝ',
  unsubscribeInfo: 'የምዝገባ ስረዛ መረጃ',
  loadingUnsubscribeInfo: 'የምዝገባ ስረዛ መረጃ በመጫን ላይ...',
  unsubscribeContentNotAvailable: 'የምዝገባ ስረዛ መረጃ በአሁኑ ጊዜ አይገኝም።',
  dcbUnsubscribeButton: 'ምዝገባዬን ሰርዝ',
  dcbUnsubscribeConfirmTitle: 'ማረጋገጫ',
  dcbUnsubscribeConfirmMessage: 'ምዝገባዎን ለመሰረዝ እርግጠኛ ነዎት? ወደ ፕሪሚየም ይዘት መዳረሻ ያጣሉ።',
  dcbUnsubscribeSuccess: 'ምዝገባዎ በተሳካ ሁኔታ ተሰርዟል። ከአሁን በኋላ ለአገልግሎቱ አልተመዘገቡም።',
  dcbUnsubscribeError: 'ምዝገባዎን መሰረዝ አልተቻለም። ለእርዳታ እባክዎ የደንበኛ ድጋፍን ያነጋግሩ።',
  loadingPrivacyPolicy: 'የግላዊነት ፖሊሲ በመጫን ላይ...',
  privacyPolicyNotAvailable: 'የግላዊነት ፖሊሲ በአሁኑ ጊዜ አይገኝም።',
  loadingTermsConditions: 'ውሎች እና ሁኔታዎች በመጫን ላይ...',
  termsConditionsNotAvailable: 'ውሎች እና ሁኔታዎች በአሁኑ ጊዜ አይገኙም።',
  cookies: 'ኩኪዎች',
  cookiesSection: 'ኩኪዎች',
  legalSection: 'ሕጋዊ መረጃ',
  loadingCookies: 'የኩኪ መረጃ በመጫን ላይ...',
  cookiesNotAvailable: 'የኩኪ መረጃ በአሁኑ ጊዜ አይገኝም።',
  loadingLegalNotice: 'ሕጋዊ ማሳሰቢያ በመጫን ላይ...',
  legalNoticeNotAvailable: 'ሕጋዊ ማሳሰቢያ በአሁኑ ጊዜ አይገኝም።',
  loadingPricingConditions: 'የዋጋ ሁኔታዎች በመጫን ላይ...',
  pricingConditionsNotAvailable: 'የዋጋ ሁኔታዎች በአሁኑ ጊዜ አይገኙም።',
  retry: 'እንደገና ሞክር',
  noEmailApp: 'በዚህ መሣሪያ ላይ የኢሜይል መተግበሪያ አይገኝም።',
  errorOpeningEmail: 'የኢሜይል መተግበሪያውን መክፈት አልተቻለም።',
  errorOpeningSettings: 'የሥርዓት ቅንብሮችን መክፈት አልተቻለም።',
  security: 'ደህንነት',

  // Loading and errors
  loading: 'በመጫን ላይ...',
  loadingContent: 'ይዘት በመጫን ላይ...',
  preparingVideo: 'ቪዲዮ በማዘጋጀት ላይ...',

  seasonNotFound: 'ወቅት አልተገኘም',
  episodeNotFound: 'ክፍል አልተገኘም',
  rubriqueNotFound: 'ክፍል አልተገኘም',

  // Video player

  loadingVideo: 'ቪዲዮ በመጫን ላይ...',
  loadingPlayer: 'ማጫወቻ በመጫን ላይ...',
  loadingEpisodes: 'ክፍሎች በመጫን ላይ...',

  // Badges and labels
  min: 'ደቂቃ',
  enemiesToLovers: 'ከጠላቶች ወደ ፍቅረኛዎች',

  // Actions
  cancel: 'ሰርዝ',
  delete: 'ሰርዝ',
  remove: 'አስወግድ',
  removeFromList: 'ከዝርዝሬ አስወግድ',
  subscribe: 'ተመዝገብ',
  selectLanguage: 'ቋንቋ ይምረጡ',
  restartRequired: 'ዳግም ማስጀመር ያስፈልጋል',
  restartMessage: 'አዲሱን የአቀማመጥ አቅጣጫ ለመተግበር እባክዎ መተግበሪያውን እንደገና ያስጀምሩ።',
  restartToApplyLanguage: 'አዲሱን ቋንቋ ለመተግበር መተግበሪያውን እንደገና ያስጀምሩ?',
  ok: 'እሺ',
  save: 'አስቀምጥ',
  saving: 'በማስቀመጥ ላይ...',
  editProfile: 'መገለጫ አርትዕ',
  pseudo: 'ቅጽል ስም',
  enterPseudo: 'ቅጽል ስምዎን ያስገቡ',
  pseudoPlaceholder: 'ልዩ ስም ይምረጡ (ከ16 ፊደላት በታች)',
  pseudoTaken: 'ይህ ቅጽል ስም ቀድሞ ተወስዷል',
  pseudoInvalid: 'ይህ ቅጽል ስም ተገቢ ያልሆነ ይዘት ይይዛል',
  pseudoInvalidCharacters: 'ይህ ቅጽል ስም ልክ ያልሆኑ ቁምፊዎች ይይዛል',
  pseudoNotAccepted: 'እባክዎ ሌላ ቅጽል ስም ይምረጡ፣ ይህ ሊቀበል አይችልም',
  pseudoMaxLength: 'ቅጽል ስም 16 ቁምፊዎች ወይም ከዚያ ያነሰ መሆን አለበት',
  pseudoCharactersCount: '{{count}}/16 ቁምፊዎች',
  editPseudo: 'ቅጽል ስም አርትዕ',
  pseudoUpdated: 'ቅጽል ስም በተሳካ ሁኔታ ተዘምኗል',
  subtitles: 'ንዑስ ጽሑፎች',
  off: 'ጠፍቷል',
  noSubtitlesAvailable: 'ንዑስ ጽሑፎች አይገኙም',
  playbackSpeed: 'የማጫወቻ ፍጥነት',
  normalSpeed: 'መደበኛ',
  profileInformation: 'የመገለጫ መረጃ',
  dateOfBirth: 'የልደት ቀን',
  phoneNumber: 'ስልክ ቁጥር',
  enterPhoneNumber: 'ስልክ ቁጥርዎን ያስገቡ',
  notProvided: 'አልቀረበም',
  dateFormatHint: 'ቅርጸት: {format} (ለምሳሌ {example})',
  dateFormatPattern: 'ቀቀ-ወወ-ዓዓዓዓ',
  dateFormatExample: '31-12-1990',
  invalidDateFormat: 'እባክዎ ቅርጸቱን ይጠቀሙ: {format}',
  invalidDate: 'ልክ ያልሆነ ቀን',

  // Placeholders and descriptions
  discoverGenre: 'ያግኙ',

  // Time and duration
  m: 'ሚ',
  now: 'አሁን',
  minuteAbbrev: 'ደ',
  hourAbbrev: 'ሰ',
  dayAbbrev: 'ቀ',
  monthAbbrev: 'ወ',

  // History and viewing progress
  noViewingHistory: 'የእይታ ታሪክ የለም',
  episodesWillAppearHere: 'የሚመለከቷቸው ክፍሎች እዚህ ይታያሉ',
  history: 'ታሪክ',
  series: 'ተከታታዮች',
  noFavoritesYet: 'ገና ተወዳጆች የሉም',
  addContentToFavorites: 'እዚህ ለማየት ተከታታዮችን እና ክፍሎችን ወደ ተወዳጆችዎ ያክሉ',

  // My Purchases
  myPurchases: 'ግዢዎቼ',
  purchased: 'ተገዝቷል',
  myPurchasesTitle: 'የተከፈቱ ክፍሎችዎ',
  myPurchasesDescription: 'በሳንቲሞችዎ የከፈቷቸውን ሁሉንም ፕሪሚየም ክፍሎች እዚህ ያግኙ። ተጨማሪ ሳንቲሞች ለማግኘት ማየት ቀጥሉ!',
  tutorialStep1Title: 'ክፍሎችን ይመልከቱ',
  tutorialStep1Description: 'በመድረኩ ላይ ነፃ ይዘት በማየት ሳንቲሞችን ያግኙ።',
  tutorialStep2Title: 'ሽልማቶችን ይሰብስቡ',
  tutorialStep2Description: 'ተጨማሪ ሳንቲሞች ለማግኘት ተግዳሮቶችን ያጠናቅቁ እና በየቀኑ ይግቡ።',
  tutorialStep3Title: 'ፕሪሚየም ይዘት ይክፈቱ',
  tutorialStep3Description: 'ልዩ ፕሪሚየም ክፍሎችን ለመክፈት ሳንቲሞችዎን ይጠቀሙ።',
  goToRewards: 'ወደ ሽልማቶች ሂድ',

  // Gamification notifications
  userSignupNotification: 'እንኳን ደህና መጡ! መለያዎን ለመፍጠር {coins} ሳንቲሞች አግኝተዋል!',
  dailyVisitNotification: 'ለዕለታዊ ጉብኝትዎ {coins} ሳንቲሞች አግኝተዋል!',
  emailProvidedNotification: 'ኢሜይልዎን ስለሰጡ {coins} ሳንቲሞች አግኝተዋል!',
  msisdnProvidedNotification: 'ስልክ ቁጥርዎን ስለሰጡ {coins} ሳንቲሞች አግኝተዋል!',
  birthDateProvidedNotification: 'የልደት ቀንዎን ስለሰጡ {coins} ሳንቲሞች አግኝተዋል!',
  completeProfileNotification: 'መገለጫዎን ስላጠናቀቁ {coins} ሳንቲሞች አግኝተዋል!',
  pseudoProvidedNotification: 'ብጁ ቅጽል ስም ስለፈጠሩ {coins} ሳንቲሞች አግኝተዋል!',
  selectImageSource: 'የምስል ምንጭ ይምረጡ',
  takePhoto: 'ፎቶ አንሳ',
  chooseFromLibrary: 'ከቤተ-ምስል ይምረጡ',
  removeProfilePicture: 'የመገለጫ ፎቶ አስወግድ',
  removeProfilePictureConfirm: 'የመገለጫ ፎቶዎን ለማስወገድ እርግጠኛ ነዎት?',
  profilePictureUpdated: 'የመገለጫ ፎቶ በተሳካ ሁኔታ ተዘምኗል',
  profilePictureRemoved: 'የመገለጫ ፎቶ በተሳካ ሁኔታ ተወግዷል',
  failedToPickImage: 'ከቤተ-ምስል ምስል መምረጥ አልተሳካም',
  failedToTakePhoto: 'ፎቶ ማንሳት አልተሳካም',
  failedToUploadImage: 'ምስል መስቀል አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
  imageInappropriateContent: 'ምስሉ ተገቢ ያልሆነ ይዘት ይይዛል',
  failedToUpdateProfilePicture: 'የመገለጫ ፎቶ ማዘመን አልተሳካም',
  failedToRemoveProfilePicture: 'የመገለጫ ፎቶ ማስወገድ አልተሳካም',
  watchEpisodeNotification: 'ክፍል ስለተመለከቱ {coins} ሳንቲሞች አግኝተዋል!',
  watchAdsNotification: 'ማስታወቂያዎችን ስለተመለከቱ {coins} ሳንቲሞች አግኝተዋል!',
  enableNotificationsNotification: 'ማሳወቂያዎችን ስላነቁ {coins} ሳንቲሞች አግኝተዋል!',
  followSocialNotification: 'በማኅበራዊ ሚዲያ ስለተከተሉን {coins} ሳንቲሞች አግኝተዋል!',
  coinsEarnedNotification: '{coins} ሳንቲሞች አግኝተዋል!',
  coinsUsedForPremiumNotification: 'ይህን ፕሪሚየም ክፍል ለመክፈት {coins} ሳንቲሞች ተጠቅመዋል!',
  firstCoinsUsageNotification: 'እንኳን ደህና መጡ! የመጀመሪያ ፕሪሚየም ክፍልዎን በሳንቲሞች ከፍተዋል!',

  // Reward Center
  rewardCenter: 'የሽልማት ማዕከል',
  rewards: 'ሽልማቶች',
  weeklyRanking: 'ሳምንታዊ ደረጃ',
  hallOfFame: 'የክብር አዳራሽ',
  thisWeeksTopPlayers: 'የዚህ ሳምንት ምርጥ ተጫዋቾች',
  allTimeChampions: 'ዘላለማዊ ሻምፒዮኖች',
  totalCoinsAllTime: 'ጠቅላላ ሳንቲሞች',
  coinsThisWeek: 'የዚህ ሳምንት ሳንቲሞች',
  achievements: 'ስኬቶች',
  dayStreakRecord: 'ቀን ተከታታይ',
  you: 'እርስዎ',
  noRankingData: 'የደረጃ መረጃ አይገኝም',
  checkBackLaterRanking: 'ለሳምንታዊ ደረጃዎች ቆይተው ይመለሱ',
  noHallOfFameData: 'የክብር አዳራሽ መረጃ አይገኝም',
  checkBackLaterHallOfFame: 'ለዘላለማዊ ደረጃዎች ቆይተው ይመለሱ',
  coins: 'ሳንቲሞች',
  days: 'ቀናት',
  dailyCheckIn: 'ዕለታዊ መግቢያ',
  earnRewards: 'ሽልማቶች ያግኙ',
  completed: 'ተጠናቋል',
  claim: 'ሊደረግ የሚገባ',
  comingSoon: 'በቅርቡ',
  day: 'ቀን',
  today: 'ነገ',
  totalCoins: 'ጠቅላላ ሳንቲሞች',
  getCoins: 'ሳንቲሞች አግኝ፣',
  keepWatching: 'መመልከቱን ቀጥል',
  dayStreak: 'ቀን ተከታታይ',
  nextReward: 'ቀጣይ ሽልማት',
  availableTomorrow: 'ነገ ይገኛል',
  weekProgress: 'የሳምንት ግስጋሴ',
  serie: 'ተከታታይ',
  won: 'አሸነፈ',
  tomorrow: 'ነገ',
  toDo: 'ሊደረግ የሚገባ',
  firstWeek: 'የመጀመሪያ ሳምንት',
  secondWeek: 'ሁለተኛ ሳምንት',
  amazingStreak: 'አስደናቂ ተከታታይ! ቀጥሉበት!',
  overallProgress: 'አጠቃላይ ግስጋሴ',
  of: 'ከ',
  eventsCompleted: 'ተግባራት ተጠናቅቀዋል',
  ofMissionsCompleted: 'ተልዕኮዎች ተጠናቅቀዋል',

  // Gamification event categories
  gamificationCategoryUser: 'ተጠቃሚ',
  gamificationCategoryProfile: 'መገለጫ',
  gamificationCategoryContent: 'ይዘት',
  gamificationCategoryGeneral: 'አጠቃላይ',
  gamificationCategoryDailyMission: 'ዕለታዊ ተልዕኮ',
  gamificationCategoryWelcomeMissions: 'የእንኳን ደህና መጡ ተልዕኮዎች',
  gamificationCategoryWatchMissions: 'የእይታ ተልዕኮዎች',
  gamificationCategoryOnceAYear: 'በዓመት አንድ ጊዜ',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'ተልዕኮዎችን ያጠናቅቁ እና ሳንቲሞችን ያግኙ!',
  gamificationFeature1Title: 'መለያዎን ይፍጠሩ',
  gamificationFeature1Desc: 'ሲመዘገቡ {{coins}} የእንኳን ደህና መጡ ሳንቲሞች ያግኙ',
  gamificationFeature2Title: 'ክፍሎችን ይመልከቱ',
  gamificationFeature2Desc: 'ለእያንዳንዱ ክፍል {{coins}} ሳንቲሞች ያግኙ',
  gamificationFeature3Title: 'በደረጃ ይውጡ',
  gamificationFeature3Desc: 'በየሳምንቱ ከሌሎች አባላት ጋር ይወዳደሩ',
  gamificationFeature4Title: 'ፕሪሚየም ክፍሎችን ይክፈቱ',
  gamificationFeature4Desc: 'ተጨማሪ ክፍሎችን ለማየት ሳንቲሞችዎን ይጠቀሙ',
  gamificationBonusText: '+{{coins}} ሳንቲሞች ሲመዘገቡ ነፃ!',
  createAccount: 'መለያዬን ፍጠር',
  connectToYou: 'ግባ',

  // All Episodes Control
  allEpisodes: 'ሁሉም ክፍሎች',
  watchNow: 'አሁን ተመልከት',
  previousEpisode: 'ቀዳሚ',
  nextEpisode: 'ቀጣይ',

  // App availability
  appNotAvailable: 'ይህ መተግበሪያ ገና በእርስዎ አገር እና ቋንቋ አይገኝም።',
  appNotAvailableSubtext: 'አገልግሎታችንን ወደ ተጨማሪ ክልሎች ለማስፋፋት እየሠራን ነው።',

  // Biometric authentication
  biometricLogin: 'ባዮሜትሪክ መግቢያ',
  signInWithBiometric: 'በባዮሜትሪክ ግባ',
  signInWithWebAuthn: 'በWebAuthn ግባ',
  signInWithFaceId: 'በFace ID ግባ',
  signInWithTouchId: 'በTouch ID ግባ',
  enableBiometric: 'ባዮሜትሪክ መግቢያ አንቃ',
  disableBiometric: 'ባዮሜትሪክ መግቢያ አሰናክል',
  biometricNotAvailable: 'ባዮሜትሪክ ማረጋገጫ በዚህ መሣሪያ ላይ አይገኝም',
  biometricAuthFailed: 'ባዮሜትሪክ ማረጋገጫ አልተሳካም',
  biometricDataMissing: 'የባዮሜትሪክ መግቢያ መረጃ ጠፍቷል። እባክዎ በOTP ይግቡ፣ ከዚያ በመገለጫ ቅንብሮችዎ ውስጥ ባዮሜትሪክ መግቢያን እንደገና ያንቁ።',
  biometricNoUserData: 'እባክዎ መጀመሪያ ይግቡ፣ ከዚያ በመገለጫ ቅንብሮችዎ ውስጥ ባዮሜትሪክ መግቢያን ያንቁ።',
  biometricUnexpectedError: 'ያልተጠበቀ ስህተት ተከስቷል። እባክዎ በOTP ይግቡ፣ ከዚያ በመገለጫ ቅንብሮችዎ ውስጥ ባዮሜትሪክ መግቢያን እንደገና ያንቁ።',
  biometricAuthCancelled: 'ባዮሜትሪክ ማረጋገጫ ተሰርዟል። እባክዎ እንደገና ይሞክሩ።',
  webauthnNotEnabled: 'እባክዎ መጀመሪያ ይግቡ፣ ከዚያ በመገለጫ ቅንብሮችዎ ውስጥ WebAuthn መግቢያን ያንቁ።',
  webauthnCancelled: 'WebAuthn ማረጋገጫ ተሰርዟል። እባክዎ እንደገና ይሞክሩ።',
  webauthnFailed: 'WebAuthn ማረጋገጫ አልተሳካም',
  biometricLoginEnabled: 'ባዮሜትሪክ መግቢያ ነቅቷል',
  biometricLoginDisabled: 'ባዮሜትሪክ መግቢያ ተሰናክሏል',
  webauthnLoginEnabled: 'WebAuthn መግቢያ ነቅቷል',
  webauthnLoginDisabled: 'WebAuthn መግቢያ ተሰናክሏል',
  faceIdLoginEnabled: 'Face ID መግቢያ ነቅቷል',
  faceIdLoginDisabled: 'Face ID መግቢያ ተሰናክሏል',
  touchIdLoginEnabled: 'Touch ID መግቢያ ነቅቷል',
  touchIdLoginDisabled: 'Touch ID መግቢያ ተሰናክሏል',
  androidBiometricLoginEnabled: 'ባዮሜትሪክ መግቢያ ነቅቷል',
  androidBiometricLoginDisabled: 'ባዮሜትሪክ መግቢያ ተሰናክሏል',
  failedToEnableBiometric: 'ባዮሜትሪክ መግቢያ ማንቃት አልተሳካም',
  failedToDisableBiometric: 'ባዮሜትሪክ መግቢያ ማሰናከል አልተሳካም',
  failedToEnableWebauthn: 'WebAuthn መግቢያ ማንቃት አልተሳካም',
  failedToDisableWebauthn: 'WebAuthn መግቢያ ማሰናከል አልተሳካም',
  success: 'ተሳክቷል',
  enableBiometricPrompt: 'ለቀጣይ ጊዜ ፈጣን መግቢያ ባዮሜትሪክ ማረጋገጫ ማንቃት ይፈልጋሉ?',
  enableBiometricPromptIos: 'ለቀጣይ ጊዜ ፈጣን መግቢያ {authType} ማንቃት ይፈልጋሉ?',
  'Enable {{authType}}?': '{{authType}} ማንቃት?',
  'Would you like to enable {{authType}} for faster login?': 'ለፈጣን መግቢያ {{authType}} ማንቃት ይፈልጋሉ?',
  '{{authType}} login has been enabled!': '{{authType}} መግቢያ ነቅቷል!',
  'Failed to enable {{authType}} login. Please try again later.': '{{authType}} መግቢያ ማንቃት አልተሳካም። እባክዎ ቆይተው እንደገና ይሞክሩ።',
  biometricLoginTitle: 'ባዮሜትሪክ መግቢያ',
  faceIdLogin: 'Face ID መግቢያ',
  touchIdLogin: 'Touch ID መግቢያ',
  useBiometricToSignIn: 'በፍጥነት ለመግባት የጣት አሻራ ወይም የፊት መክፈቻ ይጠቀሙ',
  enableBiometricForSignIn: 'ለፈጣን መግቢያ የጣት አሻራ ወይም የፊት መክፈቻ ያንቁ',
  useFaceIdToSignIn: 'በፍጥነት ለመግባት Face ID ይጠቀሙ',
  enableFaceIdForSignIn: 'ለፈጣን መግቢያ Face ID ያንቁ',
  useTouchIdToSignIn: 'በፍጥነት ለመግባት Touch ID ይጠቀሙ',
  enableTouchIdForSignIn: 'ለፈጣን መግቢያ Touch ID ያንቁ',

  // Delete account
  deleteMyAccount: 'መለያዬን ሰርዝ',
  deleteAccountConfirmation: 'የሰረዛ ማረጋገጫ',
  deleteAccountWarningNotSubscribed: 'መለያዎን በመሰረዝ እንቀጥላለን። ካረጋገጡ በኋላ Hekaya መድረስ አይችሉም።\n\nሆኖም ግን፣ በደንቦች መሠረት፣ ለምሳሌ ለአለመግባባት መፍታት ዓላማ የተወሰነ መረጃን በአስተማማኝ ሁኔታ እንጠብቃለን።',
  deleteAccountWarningSubscribed: 'በአሁኑ ጊዜ ንቁ ምዝገባ አለዎት። እባክዎ መጀመሪያ ይሰርዙት። የምዝገባ ስረዛ መመሪያዎችን "መለያዬ"፣ "ምዝገባ ሰርዝ" ውስጥ ያገኛሉ። ምዝገባው ከተሰረዘ በኋላ መለያዎን መሰረዝ ይችላሉ።\n\nመለያዎን በመሰረዝ እንቀጥላለን። ካረጋገጡ በኋላ Hekaya መድረስ አይችሉም።\n\nሆኖም ግን፣ በደንቦች መሠረት፣ ለምሳሌ ለአለመግባባት መፍታት ዓላማ የተወሰነ መረጃን በአስተማማኝ ሁኔታ እንጠብቃለን።',
  iConfirm: 'አረጋግጣለሁ',
  deletingAccount: 'መለያ በመሰረዝ ላይ...',
  accountDeleted: 'መለያ ተሰርዟል',
  accountDeletedSuccess: 'መለያዎ በተሳካ ሁኔታ ተሰርዟል',
  accountDeleteError: 'መለያ በመሰረዝ ላይ ስህተት',
  activeSubscriptionErrorTitle: 'ንቁ ምዝገባ',
  activeSubscriptionErrorMessage: 'መለያዎን ለመሰረዝ ከመቻልዎ በፊት ምዝገባዎን መሰረዝ አለብዎት።',
  gracePeriodErrorTitle: 'ስረዛ ገና አይቻልም',
  gracePeriodErrorMessage: 'ምዝገባዎ ተሰርዟል፣ ነገር ግን እስከ ማለቂያ ቀኑ ድረስ ንቁ ነው። ይህ ጊዜ ካለቀ በኋላ መለያዎን መሰረዝ ይችላሉ።',
  gracePeriodBannerTitle: 'ምዝገባ ተሰርዟል',
  gracePeriodBannerMessage: 'ምዝገባዎ ተሰርዟል ነገር ግን እስከ {{date}} ድረስ ንቁ ነው። እስከዚያ ጊዜ ድረስ ወደ ሁሉም ፕሪሚየም ይዘት መዳረሻ ይቀጥላሉ።',
  notBilledDenyBannerTitle: 'ምዝገባ ታግዷል',
  notBilledDenyBannerMessage: 'ምዝገባዎ በክፍያ ችግር ምክንያት ጊዜያዊ ታግዷል። ወደ አገልግሎታችን ተመልሰው ለመግባት *9 መለያዎን ይሙሉ። ክፍያ ሲሰራ የ Hekaya መለያዎ እንደገና ይነቃል።',

  // Network connection
  noInternetConnection: 'የኢንተርኔት ግንኙነት አይገኝም። እባክዎ ግንኙነትዎን ያረጋግጡ እና እንደገና ይሞክሩ።',
  noInternetConnectionShort: 'የኢንተርኔት ግንኙነት የለም',
  checkInternetConnection: 'እባክዎ የኢንተርኔት ግንኙነትዎን ያረጋግጡ',
  connectionRequired: 'የኢንተርኔት ግንኙነት ያስፈልጋል',
  dismiss: 'ያለ ኢንተርኔት ቀጥል',
  slowNetworkDetected: 'ቀርፋፋ አውታረ መረብ ተገኝቷል',
  poorNetworkConnection: 'የአውታረ መረብ ግንኙነትዎ ችግር እያጋጠመው ነው። ቪዲዮ መጫን ከተለመደው በላይ ጊዜ እየፈጀ ነው።',
  loadingTime: 'የመጫኛ ጊዜ',
  slowConnection: 'ቀርፋፋ ግንኙነት',

  // App version
  version: 'ስሪት',

  // Image cache
  imageCacheStorage: 'የምስል ክሽ ማከማቻ',
  cachedImages: 'በክሽ ያሉ ምስሎች',
  storageUsed: 'ጥቅም ላይ የዋለ ማከማቻ',
  expiredImages: 'ጊዜያቸው ያለፈ ምስሎች',
  clearExpiredCache: 'ጊዜያቸው ያለፉትን አጽዳ',
  clearAllCache: 'ሁሉንም አጽዳ',
  clearing: 'በማጽዳት ላይ...',
  clearImageCache: 'የምስል ክሽ አጽዳ',
  clearImageCacheConfirmation: 'ሁሉንም በክሽ ያሉ ምስሎችን ለማጽዳት እርግጠኛ ነዎት? ይህ ማከማቻ ቦታ ነፃ ያደርጋል ነገር ግን ምስሎች እንደገና መውረድ ይኖርባቸዋል።',
  clearCache: 'ክሽ አጽዳ',
  cacheCleared: 'ክሽ በተሳካ ሁኔታ ተጸዳ! {{count}} ምስሎች ተወግደዋል።',
  expiredCacheCleared: 'ጊዜው ያለፈ ክሽ ተጸዳ! {{count}} ጊዜያቸው ያለፈ ምስሎች ተወግደዋል።',
  noExpiredCache: 'ጊዜው ያለፈ ምስል የለም ለማጽዳት።',
  failedToClearCache: 'ክሽ ማጽዳት አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
  cacheAutoClears30Days: 'ምስሎች ከ30 ቀናት በኋላ በራስ-ሰር ይጸዳሉ',
  info: 'መረጃ',

  // Pagination
  scrollForMore: 'ለተጨማሪ ያንሸራትቱ',
  noMoreContent: 'የዝርዝሩ መጨረሻ',
  loadingMore: 'በመጫን ላይ...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'ይግቡ ወይም ነፃ መለያ ይፍጠሩ',
    subscriptionWelcomeTitle: 'ለምዝገባዎ እናመሰግናለን!',
    subscriptionWelcomeMessage: 'የመጨረሻ ደረጃ: ድራማዎችን ማየት ለመጀመር መለያ ለመፍጠር ይመዝገቡ ወይም ወደ ነባር መለያ ይግቡ።',
    emailPlaceholder: 'ኢሜይል አድራሻ',
    phonePlaceholder: 'ስልክ ቁጥር',
    emailOrPhonePlaceholder: 'ኢሜይል ወይም ስልክ ቁጥር',
    continue: 'ቀጥል',
    continueWithGoogle: 'በGoogle ቀጥል',
    continueWithApple: 'በApple ቀጥል',
    termsPrefix: 'በመቀጠል የእኛን ይቀበላሉ',
    termsOfService: 'የአገልግሎት ውሎች',
    privacyPolicy: 'የግላዊነት ፖሊሲ',
    confirmEmail: 'ኢሜይል አድራሻ ያረጋግጡ',
    confirmYourEmail: 'ኢሜይል አድራሻዎን ያረጋግጡ',
    confirmPhone: 'ስልክ ቁጥር ያረጋግጡ',
    confirmYourPhone: 'ስልክ ቁጥርዎን ያረጋግጡ',
    codeSentTo: 'ኮድ ልከናል ወደ',
    codeSentToPhone: 'ኮድ ልከናል ወደ',
    enterCodeBelow: 'መለያዎን ለማረጋገጥ ከዚህ በታች ያስገቡት።',
    resendCode: 'ኮድ እንደገና ላክ',
    resendIn: 'እንደገና ላክ በ',
    verify: 'አረጋግጥ',
    connectingInProgress: 'በመገናኘት ላይ...',
    accountCreated: 'መለያ ተፈጥሯል',
    stayUpdatedTitle: 'የቅርብ ጊዜ ዜናዎችን ማወቅ ይፈልጋሉ?',
    stayUpdatedDescription: 'ግላዊ ቅናሾችን፣ አነቃቂ ይዘት፣ የመሣሪያ ምክሮችን እና ስለ ፈጠራዎቻችን መረጃ ልንልክልዎ እንወዳለን።',
    learnMore: 'ተጨማሪ ይወቁ',
    subscribe: 'ተመዝገብ',
    noThanks: 'አይ አመሰግናለሁ',
    enterEmailOrPhone: 'እባክዎ ኢሜይልዎን ወይም ስልክ ቁጥርዎን ያስገቡ',
    sendFailed: 'ኮድ መላክ አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
    enterCompleteCode: 'እባክዎ ሙሉውን 6-አሃዝ ኮድ ያስገቡ',
    verificationFailed: 'ማረጋገጫ አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
    invalidCode: 'ልክ ያልሆነ ኮድ። እባክዎ እንደገና ይሞክሩ።',
    codeExpired: 'ኮድ ጊዜው አልፏል። እባክዎ አዲስ ይጠይቁ።',
    checkSpamFolder: 'ስፓም ፎልደርዎን ለማረጋገጥ ያስታውሱ',
    dcbValidatingSubscription: 'ምዝገባዎን በማረጋገጥ ላይ...',
    dcbActivating: 'ምዝገባዎን በማንቃት ላይ...',
    dcbSuccessTitle: 'ምዝገባ ነቅቷል!',
    dcbSuccessMessage: 'ምዝገባዎ በተሳካ ሁኔታ ነቅቷል። አሁን ሁሉንም ይዘት መደሰት ይችላሉ።',
    dcbStartWatching: 'ማየት ጀምር',
    dcbErrorTitle: 'የማንቃት ስህተት',
    dcbErrorRetry: 'ምዝገባዎን በማንቃት ላይ ስህተት ተከስቷል። እባክዎ እንደገና ይሞክሩ።',
    dcbPaymentNotFound: 'ምዝገባ አልተገኘም። እባክዎ ማገናኛዎን ያረጋግጡ ወይም ድጋፍን ያነጋግሩ።',
    dcbRetryButton: 'እንደገና ሞክር',
    dcbIdentityMismatchPhone: 'ለምዝገባ ጥቅም ላይ የዋለው ስልክ ቁጥር {{identifier}} ነው። እባክዎ መለያዎን ለመፍጠር ይህን ቁጥር ይጠቀሙ።',
    dcbIdentityMismatchEmail: 'ለምዝገባ ጥቅም ላይ የዋለው ኢሜይል {{identifier}} ነው። እባክዎ መለያዎን ለመፍጠር ይህን ኢሜይል ይጠቀሙ።',
    dcbRecoveryBanner: 'በመጠባበቅ ላይ ያለ ምዝገባ ተገኝቷል። ለመድረስ መለያዎን ይፍጠሩ።',
    dcbAlreadySubscribed: 'ቀድሞ በሞባይል ክፍያ ተመዝግበዋል?',
    dcbEnterPhone: 'በክፍያ ጊዜ ጥቅም ላይ የዋለውን ስልክ ቁጥር ያስገቡ:',
    dcbRecoverButton: 'ወደነበረው መልስ',
    dcbMsisdnNotFound: 'ለዚህ ቁጥር በመጠባበቅ ላይ ያለ ምዝገባ አልተገኘም።',
    dcbMsisdnRecoveryFailed: 'ወደነበረው መመለስ አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
    invalidPhoneNumber: 'ልክ ያልሆነ ስልክ ቁጥር።',
  },
  and: 'እና',
  smartBannerSubtitle: 'በመተግበሪያው ውስጥ የተሻለ ተሞክሮ',
  smartBannerOpen: 'ክፈት',
  paymentVerifying: 'ምዝገባዎን በማረጋገጥ ላይ...',
  paymentSuccessTitle: 'ምዝገባ ነቅቷል!',
  paymentSuccessMessage: 'እንኳን ደስ አለዎት፣ ወደ ሁሉም ፕሪሚየም ይዘት መዳረሻ አለዎት።',
  paymentSuccessButton: 'ማየት ጀምር',
  paymentPendingMessage: 'ክፍያዎ ተቀብለናል። ምዝገባዎ በቅርቡ ንቁ ይሆናል።',
  paymentRefreshButton: 'አድስ',
  redirectingToPayment: 'ወደ ክፍያ ገጽ በማዘዋወር ላይ...',
  webPaymentIframeErrorTitle: 'የክፍያ ገጽ አይገኝም',
  webPaymentIframeErrorMessage: 'የክፍያ ገጹ በመተግበሪያው ውስጥ መጫን አልተቻለም። በአዲስ ትር ሊከፍቱት ይችላሉ።',
  webPaymentOpenExternal: 'በአዲስ ትር ክፈት',

  // Premium subscription card
  enterPremiumExperience: 'ወደ ተሞክሮ ይግቡ',
  popular: 'ታዋቂ',
  mobileInvoice: 'ሞባይል ክፍያ',
  mobileInvoicePrice: '€9.99/ወር',
  mobileInvoiceDescription: 'በስልክ ሂሳብዎ ላይ ክፍያ። ቀላል እና ፈጣን።',
  cardAppleGooglePay: 'ካርድ / Apple Pay / Google Pay',
  cardPaymentDescription: 'በካርድ፣ Apple Pay ወይም Google Pay ደህንነቱ የተጠበቀ ክፍያ።',
  dcbPaymentOfferDescription: 'በስልክ ሂሳብዎ ላይ ክፍያ። ቀላል እና ፈጣን።',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'ምዝገባው በእርስዎ Apple App Store መለያ በኩል ይከፈላል እና ይተዳደራል።',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'ምዝገባው በእርስዎ Google Play Store መለያ በኩል ይከፈላል እና ይተዳደራል።',
  upgradeToPremium: 'ወደ ፕሪሚየም ያሻሽሉ',
  cancelAnytimeNoCommitment: 'በማንኛውም ጊዜ ይሰርዙ · ቁርጠኝነት የለም',
  whyBecomeVip: 'ለምን VIP ይሁኑ?',
  joinPremiumCommunity: 'የ Hekaya ፕሪሚየም ማህበረሰብን ይቀላቀሉ',
  unlimitedAccessShort: 'ወደ ሁሉም ተከታታዮች እና ክፍሎች ያልተገደበ መዳረሻ።\nበፈለጉት ጊዜ፣ በፈለጉት ቦታ ይመልከቱ።',
};
